import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { UserIntegrationsResponse } from "@common/dto/user/user-integrations-response.dto";
import { getUserIntegrations } from "@lib/user";
import { useScope } from "@state/scopeContext.lib";
import { financialConnectionsQueryKey } from "queryClient";

interface UseUserIntegrationsOptions<TData> {
    select?: (data: UserIntegrationsResponse) => TData;
}

export function useUserIntegrations<TData = UserIntegrationsResponse>(
    options?: UseUserIntegrationsOptions<TData>,
): UseQueryResult<TData> {
    const { workspaceId } = useScope();
    return useQuery({
        queryKey: [financialConnectionsQueryKey, workspaceId],
        queryFn: () => getUserIntegrations(workspaceId ?? ""),
        enabled: Boolean(workspaceId),
        select: options?.select,
    });
}
